import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import './QoreTalks.css';

const NAV = [
  { id: 'home', path: '/qoretalks', labelKey: 'qoreTalks.pageTitle' },
  { id: 'live', path: '/qoretalks/live', labelKey: 'nav.liveStream', live: true },
  { id: 'apply', path: '/qoretalks/apply', labelKey: 'qoreTalks.applyToSpeak' },
  { id: 'subscribe', path: '/qoretalks/subscribe', labelKey: 'nav.subscribe' },
];

export const getCategoryStyle = (category) => {
  const map = {
    AI: { bg: '#312e81', text: '#a5b4fc', accent: '#6366f1' },
    Web3: { bg: '#1c3553', text: '#93c5fd', accent: '#3b82f6' },
    Entrepreneurship: { bg: '#3b2a00', text: '#fcd34d', accent: '#f59e0b' },
    Career: { bg: '#14532d', text: '#86efac', accent: '#22c55e' },
    DevOps: { bg: '#1e1b4b', text: '#c4b5fd', accent: '#8b5cf6' },
    Design: { bg: '#500724', text: '#fda4af', accent: '#f43f5e' },
    Manufacturing: { bg: '#164e63', text: '#67e8f9', accent: '#06b6d4' },
  };
  const c = map[category] || { bg: '#1e293b', text: '#94a3b8', accent: '#64748b' };
  return {
    '--qt-cat-bg': c.bg,
    '--qt-cat-text': c.text,
    '--qt-cat-accent': c.accent,
    '--qt-accent': c.accent,
  };
};

export const fmtDuration = (mins) => {
  const m = Number(mins) || 0;
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}m`;
};

export const fmtViews = (n) => {
  const v = Number(n) || 0;
  return v >= 1000 ? `${(v / 1000).toFixed(1)}k` : String(v);
};

const QoreTalksShell = ({
  children,
  activeTab,
  hero,
  liveStrip,
  mainClass = '',
  hideNav = false,
  fullBleed = false,
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  const resolveActive = () => {
    if (activeTab) return activeTab;
    const p = location.pathname;
    if (p.startsWith('/qoretalks/live')) return 'live';
    if (p.startsWith('/qoretalks/apply')) return 'apply';
    if (p.startsWith('/qoretalks/subscribe')) return 'subscribe';
    if (p.startsWith('/qoretalks/episodes')) return 'home';
    return 'home';
  };

  const current = resolveActive();

  return (
    <div className="qt-page">
      <Header />

      {hero && (
        <header className="qt-hero">
          {hero.badge && (
            <div className="qt-hero__badge">
              <span className="qt-nav__dot" aria-hidden />
              {hero.badge}
            </div>
          )}
          {hero.title && (
            <h1 className="qt-hero__title">
              {hero.titleAccent ? (
                <>
                  {hero.title}{' '}
                  <span>{hero.titleAccent}</span>
                </>
              ) : (
                hero.title
              )}
            </h1>
          )}
          {hero.subtitle && <p className="qt-hero__subtitle">{hero.subtitle}</p>}
          {hero.actions && <div className="qt-hero__actions">{hero.actions}</div>}
          {hero.stats && <div className="qt-hero__stats">{hero.stats}</div>}
          {hero.extra}
        </header>
      )}

      {liveStrip}

      {!hideNav && (
        <nav className="qt-nav" aria-label="QoreTalks">
          <div className="qt-nav__inner">
            <Link to="/qoretalks" className="qt-nav__brand">
              <span className="qt-nav__dot" aria-hidden />
              QoreTalks
            </Link>
            {NAV.map((item) => (
              <Link
                key={item.id}
                to={item.path}
                className={[
                  'qt-nav__link',
                  current === item.id ? 'qt-nav__link--active' : '',
                  item.live ? 'qt-nav__link--live' : '',
                ].filter(Boolean).join(' ')}
              >
                {t(item.labelKey)}
              </Link>
            ))}
          </div>
        </nav>
      )}

      {fullBleed ? children : (
        <main className={`qt-main ${mainClass}`.trim()}>{children}</main>
      )}

      <Footer />
    </div>
  );
};

export default QoreTalksShell;